import {
  ComputedFieldProps,
  DropdownOption,
} from "@dbn/omnichannel-design-system-g4p";
import { option, record } from "fp-ts";
import { constant, pipe } from "fp-ts/function";
import { Option } from "fp-ts/Option";
import { useFormatMessage } from "../../../intl";
import { DropdownField } from "../../../Common/DropdownField/DropdownField";
import {
  dropdownOptionToValue,
  selectedDropdownOption,
} from "../../../Common/selectDropdownOption";
import * as api from "../api";
import { useFormatEmploymentType } from "../domain";
import { ReadOnlyFieldToValue } from "../../../Common/ReadOnlyField/ReadOnlyFieldToValue";

type Props = {
  fieldProps: ComputedFieldProps<Option<api.EmploymentType>>;
};

export function EmploymentTypeDropdown({ fieldProps }: Props) {
  const formatMessage = useFormatMessage();
  const formatEmploymentType = useFormatEmploymentType();

  const dropdownOptions: Array<DropdownOption<api.EmploymentType>> = pipe(
    api.EmploymentType.keys,
    record.collect(employmentType => ({
      value: employmentType,
      label: formatEmploymentType(employmentType),
    }))
  );

  const onChange = (
    dropdownOption: Option<DropdownOption<api.EmploymentType>>
  ) => {
    fieldProps.onChange(dropdownOptionToValue(dropdownOption));
  };

  const value = selectedDropdownOption(fieldProps.value, dropdownOptions);

  return fieldProps.disabled ? (
    <ReadOnlyFieldToValue
      value={pipe(
        value,
        option.map(({ label }) => String(label)),
        option.getOrElse(constant(""))
      )}
      label={formatMessage("StandardLoan.EmployedCard.employmentType")}
    />
  ) : (
    <DropdownField
      {...fieldProps}
      clearable={false}
      label={formatMessage("StandardLoan.EmployedCard.employmentType")}
      onChange={onChange}
      options={dropdownOptions}
      placeholder={formatMessage(
        "StandardLoan.EmployedCard.employmentTypePlaceholder"
      )}
      searchable={false}
      value={value}
    />
  );
}
